import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import orderService from "../Services/orderService";
import Loading from "../Modals/Loading";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import OrderInvoice from "../Modals/OrderInvoice";
import PerfomaInvoice from "../Modals/PerfomaInvoice";
import { CiDeliveryTruck, CiReceipt } from "react-icons/ci";
import { FaCheck } from "react-icons/fa6";
import { IoCreateOutline } from "react-icons/io5";
import { BiTimer } from "react-icons/bi";
import { TbTruckLoading } from "react-icons/tb";
import { LiaTruckLoadingSolid } from "react-icons/lia";

const OrderView = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [file, setFile] = useState();
  const [selectedOption, setSelectedOption] = useState("");
  const [products, setProducts] = useState([]);
  const [updateProducts, setUpdateProducts] = useState([]);
  const [showDetails, setShowDetails] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    const invokeSafely = (fn) =>
      Promise.resolve()
        .then(() => fn())
        .catch((err) => {
          console.error("Invocation error:", err);
        });

    const retrieve = async (identifier) => {
      const gatekeeper = () => !!identifier;
      if (!gatekeeper()) return null;

      const handler = async () =>
        await orderService
          .fetchByInvoice(identifier)
          .then((res) => res.order)
          .catch((fail) => {
            throw fail;
          });

      return await handler();
    };

    const orchestrator = async () => {
      let sentinel = true;
      setLoading(sentinel);

      const invoiceId = (() => {
        const query = params.get("invoice");
        return typeof query === "string" ? query.trim() : null;
      })();

      try {
        const orderPayload = await retrieve(invoiceId);
        setOrder(orderPayload);
        console.log(orderPayload);
      } catch (error) {
        console.error("Failed to fetch Orders", error);
        setError(!!sentinel);
      } finally {
        sentinel = false;
        setLoading(sentinel);
      }
    };

    invokeSafely(orchestrator);
  }, []);

  const processOrderDetails = (inputData) => {
    const isValid = () =>
      Array.isArray(inputData?.details) && inputData.details.length > 0;

    if (isValid()) {
      const deepClone = (data) =>
        JSON.parse(
          JSON.stringify(Array.isArray(data) ? [...data] : { ...data }),
        );

      const encoded = JSON.parse(
        atob(
          btoa(
            JSON.stringify(
              deepClone(inputData.details).map((item) =>
                Object.entries(item).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {}),
              ),
            ),
          ),
        ),
      );

      return encoded;
    } else {
      (() => {
        const dummy =
          inputData?.details?.length === 0 ? "NothingHere" : "CorruptData";
        console.warn("processOrderDetails fallback hit:", dummy);
      })();
      return null;
    }
  };

  const normalizeCode = (code) =>
    code?.toString().replace(/-/g, "").trim().toLowerCase();

  useEffect(() => {
    if (products.length !== 0) {
      const getProducts = async () => {
        try {
          let parts = [];
          let quantities = {};
          let prices = {};

          products.forEach((single) => {
            const partNumber = normalizeCode(single["Part Number"]);
            parts.push(partNumber);
            quantities[partNumber] = single.QTY;
            prices[partNumber] = single.price;
          });

          let prods = [];

          for (const detail of order.details) {
            const vendorCode = normalizeCode(detail.vendor_code);
            if (parts.includes(vendorCode)) {
              prods.push({
                ...detail,
                quantity: quantities[vendorCode],
                price: prices[vendorCode],
              });
            } else {
              console.log("No match for:", vendorCode);
            }
          }

          setUpdateProducts(prods);
          console.log("Matched Products:", prods);
        } catch (e) {
          console.error("Error in getProducts:", e);
        }
      };

      getProducts();
    }
  }, [products]);

  const OpenModal = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const handleStatus = () => {
    let status = "";
    if (order.status === "pending") {
      status = "confirmed";
    } else if (order.status === "confirmed") {
      status = "underprocess";
    } else if (order.status === "underprocess") {
      status = "readytodeliver";
    } else if (order.status === "readytodeliver") {
      status = "dispatched";
    } else if (order.status === "dispatched") {
      status = "deliveredorders";
    }
    orderService.updateStatus(order.id, { status }).then((response) => {
      orderService
        .updateOrder({
          order: {
            id: order.id,
            amount: totalPrice,
            vat_amount: totalWithVat,
            status: status,
          },
          products: updateProducts,
        })
        .then((response) => {
          if (response.responseCode === 200) {
            navigate("/order");
          }
        });
    });
  };

  const handleContinueButton = (() => {
    return function () {
      const result = processOrderDetails(order);

      const dispatch = (data) =>
        setTimeout(
          () => {
            typeof data !== "undefined" &&
              data !== null &&
              setUpdateProducts(data);
          },
          Math.floor(Math.random() * 5),
        );

      result
        ? dispatch(result)
        : console.info("No valid result to dispatch. Handler complete.");
    };
  })();

  const convertToCSV = (data) => {
    const headers = ["vendor_code", "brand", "quantity"];

    const rows = data.map((item) => {
      return [item.vendor_code.toString(), item.brand, item.quantity].join(",");
    });

    return [headers.join(","), ...rows].join("\n");
  };

  const handleDownloadOrder = () => {
    // console.log(order)
    const groupedData = order.details.reduce((acc, item) => {
      if (!acc[item.supplier]) {
        acc[item.supplier] = [];
      }
      acc[item.supplier].push(item);
      return acc;
    }, {});
    console.log(groupedData);

    Object.keys(groupedData).forEach((brand) => {
      const csvContent = convertToCSV(groupedData[brand]);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${brand}.csv`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const downloadQuotation = () => {
    let suppliers = [];
    for (const detail of order.details) {
      if (!suppliers.includes(parseInt(detail.supplier))) {
        suppliers.push(parseInt(detail.supplier));
      }
    }
    console.log(suppliers);

    for (const supplier of suppliers) {
      const transformedData = order.details
        .filter((v) => parseInt(v.supplier) === parseInt(supplier))
        .map((item) => ({
          "Part Number": item.vendor_code,
          Brand: item.brand,
          Quantity: item.quantity,
          "Unit Price": item.price,
          "Total Price": item.quantity * item.price,
        }));

      const fullData = [...transformedData];

      const worksheet = xlsx.utils.json_to_sheet(fullData);

      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Purchase_" + supplier);

      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `purchase_s_${supplier}_${moment().format()}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
    }
  };

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        setFile(data);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = () => {
    if (file) {
      const workbook = xlsx.read(file, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsx.utils.sheet_to_json(worksheet);
      setProducts(json);
    } else {
      toast.error("Please upload any file!");
    }
  };

  const totalPrice = updateProducts.reduce(
    (acc, item) => acc + item.quantity * parseFloat(item.price),
    0,
  );

  const totalQuantity = order?.details.reduce(
    (acc, item) => acc + item.quantity,
    0,
  );

  const totalQuantityUnderProcess = order?.details.reduce(
    (acc, item) => acc + item.quote_quantity,
    0,
  );

  const totalInvoiceQuantity = order?.details?.reduce((sum, det) => {
    return sum + (det.invoice_quantity || 0);
  }, 0);

  const vatAmount = updateProducts.reduce(
    (acc, item) =>
      acc +
      item.quantity *
        parseFloat(item.price) *
        (parseFloat(item.vat_percentage) / 100),
    0,
  );

  const totalWithVat = totalPrice + vatAmount;

  let totalVatPrice = 0;

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg min-h-[calc(100vh-48px)] bg-white">
      {loading ? (
        <div className="mt-64">
          <Loading />
        </div>
      ) : order ? (
        <div>
          <div className="flex flex-row justify-between">
            <div className="flex flex-row items-center">
              <p className="font-bold text-3xl text-secondary">
                GAP-{order.id}
              </p>
            </div>
            <div className="flex flex-row gap-2 items-center">
              {order.status === "deliveredorders" ||
              order.status === "readytodeliver" ||
              order.status === "dispatched" ? (
                <OrderInvoice invoice={params.get("invoice")} />
              ) : (
                <PerfomaInvoice invoice={params.get("invoice")} />
              )}
              <div>
                <button
                  onClick={() => downloadQuotation()}
                  className="button-primary hidden"
                >
                  Download Order Detail
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white border shadow-md w-[60%] p-10 mt-10 rounded-3xl">
            <div className="flex flex-row gap-3 items-center">
              <div className="text-cyan-700 text-xl font-semibold flex flex-row items-center gap-2">
                <h1>{order.customer_company_name}</h1>
              </div>
            </div>
            <div className="grid grid-cols-2">
              <div>
                <div className="text-sm font-medium text-gray-400 mt-4">
                  <p>
                    Email:{" "}
                    <span className="font-semibold text-gray-700">
                      {order.customer_email}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Phone no:{" "}
                    <span className="font-semibold text-gray-700">
                      {order.phone}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Created Date:{" "}
                    <span className="font-semibold text-gray-700">
                      {moment(order?.created_at).format("LL")}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Order Date:{" "}
                    <span className="font-semibold text-gray-700">
                      {moment(order?.order_date).format("LL")}
                    </span>
                  </p>
                </div>
              </div>
              <div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Delivery Date:{" "}
                    <span className="font-semibold text-gray-700">
                      {order.delivery_date === null
                        ? "N/A"
                        : moment(order?.delivery_date).format("LL")}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Reference No:{" "}
                    <span className="font-semibold text-gray-700">
                      {order.reference_no}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Payment Status:{" "}
                    <span
                      className={`font-semibold ${
                        order.payment_status === "paid"
                          ? "text-green-500"
                          : order.payment_status === "notpaid"
                            ? "text-red-500"
                            : order.payment_status === "check_received"
                              ? "text-orange-600"
                              : "text-amber-500"
                      }`}
                    >
                      {order.payment_status === "paid"
                        ? "Paid"
                        : order.payment_status === "notpaid"
                          ? "Unpaid"
                          : order.payment_status === "check_received"
                            ? "Check Received"
                            : "Partial"}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-4">
                  <p>
                    Order Status:{" "}
                    <span
                      className={`px-4 py-1 rounded-md font-bold text-[12px] ${
                        order.status === "pending"
                          ? "bg-yellow-500/20 text-amber-600"
                          : order.status === "confirmed"
                            ? "bg-blue-500/20 text-blue-600"
                            : order.status === "underprocess"
                              ? "bg-orange-500/20 text-orange-600"
                              : order.status === "readytodeliver"
                                ? "bg-purple-500/20 text-purple-600"
                                : order.status === "dispatched"
                                  ? "bg-cyan-500/20 text-cyan-600"
                                  : "bg-green-500/20 text-green-600"
                      }`}
                    >
                      {order.status === "pending"
                        ? "Pending"
                        : order.status === "confirmed"
                          ? "Confirmed"
                          : order.status === "underprocess"
                            ? "Under Process"
                            : order.status === "readytodeliver"
                              ? "Ready To Deliver"
                              : order.status === "dispatched"
                                ? "Dispatched"
                                : "Delivered"}
                    </span>
                  </p>
                  <p className="ml-5"></p>
                </div>
              </div>
            </div>
          </div>

          {order.receipt !== "0" && (
            <a
              href={order.receipt}
              target="blank"
              rel="noopener noreferrer"
              className={`w-fit mt-10 bg-cyan-600 text-white border font-medium text-xs px-8 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <CiReceipt className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
              <div>View Receipt</div>
            </a>
          )}
          <div className="flex flex-row justify-between mt-10">
            <div className="font-bold text-2xl text-secondary">
              Order Details
            </div>
            <button
              onClick={() => setShowDetails((prev) => !prev)}
              className="flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 hover:shadow transition-all duration-300"
            >
              <svg
                className={`w-4 h-4 transition-transform duration-300 ${showDetails ? "rotate-180" : ""}`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
              </svg>
              {showDetails ? "Hide Details" : `Show Details`}
            </button>
          </div>
          <div
            className={`transition-all duration-500 overflow-hidden ${showDetails ? "opacity-100 mt-4" : "max-h-0 opacity-0"}`}
          >
            <div className="table-div">
              <table>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px]">
                    <th className="py-3 pl-4 rounded-l-xl w-[3%]">Sr No.</th>
                    <th className="py-3 pl-4 w-[5%]">Vendor Code</th>
                    <th className="py-3 pl-4 w-[5%]">Brand</th>
                    <th className="py-3 text-center w-[3%]">Qty</th>
                    <th className="py-3 pl-4 w-[5%]">Price</th>

                    <th className="py-3 pl-4 w-[3%] border-l-2">Qty</th>
                    <th className="py-3 pl-4 w-[4%]">Price</th>

                    <th className="py-3 pl-4 w-[3%] border-l-2">Qty</th>
                    <th className="py-3 pl-4 w-[5%]">Price</th>

                    <th className="py-3 pl-4 w-[7%] border-l-2 text-center">
                      Price Excl VAT
                    </th>
                    <th className="py-3 w-[5%] text-center pl-4">VAT</th>
                    <th className="py-3 pl-4 rounded-r-xl w-[7%] text-center">
                      Incl VAT
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order.details &&
                    order.details.map((detail, index) => {
                      let baseTotal = 0;
                      if (
                        order.status === "confirmed" ||
                        order.status === "pending"
                      ) {
                        baseTotal = detail.price * detail.quantity;
                      } else if (order.status === "underprocess") {
                        baseTotal = detail.quote_price * detail.quantity;
                      } else {
                        baseTotal =
                          detail.invoice_price * detail.invoice_quantity;
                      }

                      const vat =
                        (baseTotal * (detail.vat_percentage || 0)) / 100;
                      const totalWithVat = baseTotal + vat;

                      return (
                        <tr
                          key={index}
                          className="bg-accent border-b border-gray-100 text-left"
                        >
                          <td className="pl-4 py-2 rounded-l-xl">
                            {index + 1}.
                          </td>
                          <td className="pl-4 py-2 font-bold">
                            {detail.vendor_code}
                          </td>
                          <td className="pl-4 py-2 font-bold">
                            {detail.brand}
                          </td>
                          <td className="text-center py-2">
                            {detail.quantity}
                          </td>
                          <td className="pl-4 py-2">
                            {parseFloat(detail.price).toFixed(2)}
                          </td>

                          <td className="pl-4 py-2 border-l-2">
                            {detail.quantity}
                          </td>
                          <td className="pl-4 py-2">
                            {parseFloat(detail.quote_price).toFixed(2)}
                          </td>

                          <td className="pl-4 py-2 border-l-2">
                            {detail.invoice_quantity}
                          </td>
                          <td className="py-2 pl-4">
                            {parseFloat(detail.invoice_price).toFixed(2)}
                          </td>

                          <td className="pl-4 py-2 text-center border-l-2 font-bold text-red-400">
                            {baseTotal.toFixed(2)} AED
                          </td>
                          <td className="py-2 pl-4 text-center font-bold text-slate-500">
                            {vat.toFixed(2)} AED
                          </td>
                          <td className="pl-4 py-2 text-center rounded-r-xl font-bold text-teal-600">
                            {totalWithVat.toFixed(2)} AED
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex flex-row justify-center gap-4 mt-10 flex-wrap">
            {[
              {
                label: "Total Quantity",
                value:
                  order?.status === "pending" || order?.status === "confirmed"
                    ? totalQuantity
                    : order?.status === "underprocess"
                      ? totalQuantityUnderProcess
                      : order?.status === "readytodeliver" ||
                          order?.status === "dispatched" ||
                          order?.status === "deliveredorders"
                        ? totalInvoiceQuantity
                        : 0,
              },
              { label: "Order Amount Excl VAT", value: `${order.amount} AED` },
              {
                label: "VAT Amount",
                value: `${(order.vat_amount - order.amount).toFixed(2)} AED`,
              },
              {
                label: "Order Amount Incl VAT",
                value: `${order.vat_amount} AED`,
              },
            ].map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col bg-gray-50 border border-gray-200 rounded-xl px-5 py-3"
              >
                <span className="text-[10px] text-gray-400 uppercase tracking-wide font-semibold">
                  {stat.label}
                </span>
                <span className="text-sm font-bold text-gray-800 mt-1">
                  {stat.value}
                </span>
              </div>
            ))}
          </div>

          <div className="flex flex-row gap-4 mt-10 items-center justify-center ">
            {order.purchase === 0 && (
              <button
                onClick={() =>
                  navigate("/purchase/add?invoice=" + order.invoice)
                }
                className={`bg-sky-600 text-white border font-medium text-xs px-8 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
              >
                <IoCreateOutline className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                <div>Create Purchase Order</div>
              </button>
            )}
            {order.status === "underprocess" && (
              <button
                onClick={() =>
                  navigate(`/addpacking`, {
                    state: { orderData: order },
                  })
                }
                className={`bg-white text-primary border font-medium text-xs px-8 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
              >
                <IoCreateOutline className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                <div>Create Packing</div>
              </button>
            )}
            <div>
              {order.status === "deliveredorders" ? (
                <div
                  className={`flex flex-row items-center gap-2 text-green-600 px-8 py-3 font-semibold uppercase border rounded-md`}
                >
                  <FaCheck />
                  Delivered
                </div>
              ) : (
                <>
                  {order.status !== "underprocess" && (
                    <button
                      onClick={() => handleStatus()}
                      className={`bg-white text-primary border font-medium text-xs px-8 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
                    >
                      {order.status === "pending" ? (
                        <FaCheck className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                      ) : order.status === "confirmed" ? (
                        <BiTimer className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                      ) : order.status === "underprocess" ? (
                        <TbTruckLoading className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                      ) : order.status === "readytodeliver" ? (
                        <LiaTruckLoadingSolid className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                      ) : order.status === "dispatched" ? (
                        <CiDeliveryTruck className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                      ) : (
                        "Delivered"
                      )}
                      {order.status === "pending"
                        ? "Confirm Order"
                        : order.status === "confirmed"
                          ? "Under Process"
                          : order.status === "underprocess"
                            ? "Ready To Deliver"
                            : order.status === "readytodeliver"
                              ? "Dispatch Order"
                              : order.status === "dispatched"
                                ? "Mark as Delivered"
                                : "Delivered"}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>

          {order.status === "confirmed" ? (
            <>
              {updateProducts.length > 0 ? (
                <div className="mt-2">
                  <div className=" bg-white rounded-xl">
                    <div className=" text-center pt-7 font-bold text-4xl text-primary">
                      {" "}
                      Order Details
                    </div>
                    <div className=" px- py-1 ">
                      <table className="  border-separate border-spacing-y-2">
                        <thead>
                          <tr className="uppercase w-full text-white ">
                            <th className="py-3 border-b-[2px] border-white bg-primary text-white  text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Sr No.
                            </th>
                            <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Vendor Code
                            </th>
                            <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Brand
                            </th>
                            <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Weight
                            </th>
                            <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Price
                            </th>
                            <th className="py-3 border-b-[2px]  border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Quantity
                            </th>
                            <th className="py-3 border-b-[2px] rounded-r-xl border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                              Total Price
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {updateProducts.length > 0 &&
                            updateProducts.map((detail, index) => (
                              <tr
                                key={index}
                                className="bg-gray-100 text-left text-sm"
                              >
                                <td className="pl-4 w-[3%] py-2 rounded-l-xl font-bold text-blue-500">
                                  {index + 1}.
                                </td>
                                <td className="pl-4 w-[3%] py-2 text-[11px] ">
                                  {detail.vendor_code}
                                </td>
                                <td className="pl-4 w-[3%] py-2 text-[12px] font-bold">
                                  {detail.brand}
                                </td>
                                <td className="pl-4 w-[3%] py-2 text-[12px]">
                                  {detail.weight}
                                </td>
                                <td className="pl-4 w-[3%] py-2 text-[12px]">
                                  {detail.price} AED
                                </td>
                                <td className="pl-4 w-[3%] py-2  text-[12px]">
                                  {detail.quantity}
                                </td>
                                <td className="pl-4 w-[3%] py-2 rounded-r-xl text-[12px]">
                                  {parseFloat(
                                    detail.quantity * detail.price,
                                  ).toFixed(2)}{" "}
                                  AED
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <h2 className="text-2xl font-bold text-white text-center mb-6 tracking-wide">
                    Choose How You Want to Proceed
                  </h2>

                  <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-6 mb-8">
                    <button
                      className={`relative px-6 py-3 rounded-full text-md font-semibold border transition-all duration-200 
                        ${
                          selectedOption === "upload"
                            ? "bg-neutral-700 text-white border-neutral-800 shadow-md before:content-[''] before:absolute before:w-2 before:h-2 before:rounded-full before:bg-green-500 before:left-4 pl-8 before:top-1/2 before:-translate-y-1/2"
                            : "bg-neutral-800 text-gray-300 border-neutral-700 hover:bg-neutral-700 hover:text-white"
                        }`}
                      onClick={() => setSelectedOption("upload")}
                    >
                      Upload Excel File
                    </button>

                    <button
                      className={`relative px-6 py-3 rounded-full text-md font-semibold border transition-all duration-200 
                        ${
                          selectedOption === "continue"
                            ? "bg-neutral-700 text-white border-neutral-800 shadow-md before:content-[''] before:absolute before:w-2 before:h-2 before:rounded-full before:bg-green-500 before:left-4 pl-8 before:top-1/2 before:-translate-y-1/2"
                            : "bg-neutral-800 text-gray-300 border-neutral-700 hover:bg-neutral-700 hover:text-white"
                        }`}
                      onClick={() => setSelectedOption("continue")}
                    >
                      Without File
                    </button>
                  </div>

                  {selectedOption === "upload" && (
                    <div className="w-full">
                      <div className="flex flex-row justify-between items-center w-full bg-neutral-800 p-3 rounded-xl shadow-inner">
                        <input
                          onChange={(e) => handleFileSelect(e)}
                          type="file"
                          className="w-full text-white px-4 py-2 bg-neutral-900 rounded-l-lg border border-neutral-700 focus:outline-none
                                     file:mr-4 file:py-2 file:px-5 file:rounded-lg
                                     file:border-0 file:text-sm file:font-medium
                                   file:bg-blue-600 file:text-white hover:file:bg-blue-700 transition"
                        />
                        <button
                          onClick={() => ProceedFileRead()}
                          className="bg-blue-600 hover:bg-blue-700 px-5 py-2 rounded-r-lg text-white font-semibold transition duration-200"
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  )}

                  {selectedOption === "continue" && (
                    <div className="w-full flex justify-center mt-6">
                      <button
                        onClick={() => handleContinueButton()}
                        className="bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition duration-300 font-semibold shadow-md"
                      >
                        Continue
                      </button>
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </main>
  );
};

export default OrderView;
